import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const KeywordChart: React.FunctionComponent = (props) => {

    return (
        <BPMChart {...props} title='Search' subTitle='By Keywords' type='tree'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('search/keyword', options, signal)
            }} additionalParams={{ limit: 120 }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Keywords',
                valueField: 'count',
                argumentField: 'keyword',
                smallValuesGrouping: { topCount: 20, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Search/charts/KeywordChart.tsx